import { useEffect } from "react";
import { Redirect, Route, Switch, useLocation } from "react-router-dom";
import { FormProvider, useForm } from "react-hook-form";
import { RoutesWrapper } from "../piOnboarding/styles";
import {
  ONBOARDING_BASE_PATHS,
  ONBOARDING_SESSION_TYPE_ID,
  NAVBAR_ITEMS,
  ROUTES,
} from "../../components/piOnboarding/steps/constants";
import Container from "../../components/piOnboarding/steps/container";
import Identification from "../../components/piOnboarding/steps/Identification";
import LoanPrivateInformation from "../../components/LoanApplication/privateInformation";
import Agreements from "../../components/LoanApplication/agreements";
import { LoanApplicationContextProvider } from "../../context/LoanApplication";
import { YES_NO_VAL } from "../../components/PIForm/Steps/step3/utils";
import useScrollToTop from "../../hooks/useScrollToTop";
import useCompletedSessionExit from "../../hooks/useCompletedSessionExit";

const BASE_PATH = ONBOARDING_BASE_PATHS.loan;
const LOAN_NAVBAR_ITEMS = NAVBAR_ITEMS.map((item) =>
  item.name === ROUTES.aboutServices
    ? { ...item, translationKey: "confirmationStep1" }
    : item,
);

export function LoanApplicationRoutes() {
  const { pathname, search } = useLocation();
  const { completeSession, shouldExit } = useCompletedSessionExit({
    storageKey: "completedLoanSession",
    exitUrl: "https://www.procreditbank.ge/",
  });
  const scrollToTop = useScrollToTop();
  const methods = useForm({
    shouldUnregister: false,
    defaultValues: {
      legalAddress: "",
      isActualAddressDifferent: false,
      isPep: YES_NO_VAL.no.toString(),
    },
  });

  useEffect(() => {
    scrollToTop();
  }, [pathname, scrollToTop]);

  if (shouldExit) return null;

  return (
    <RoutesWrapper>
      <Container navbarItems={LOAN_NAVBAR_ITEMS}>
        <FormProvider {...methods}>
          <LoanApplicationContextProvider>
            <Switch>
              <Route
                path={`/${BASE_PATH}/${ROUTES.identification}`}
                render={() => (
                  <Identification
                    onboardingSessionTypeId={
                      ONBOARDING_SESSION_TYPE_ID.loanApplication
                    }
                  />
                )}
              />
              <Route
                path={`/${BASE_PATH}/${ROUTES.privateInformation}`}
                component={LoanPrivateInformation}
              />
              <Route
                path={`/${BASE_PATH}/${ROUTES.aboutServices}`}
                render={() => <Agreements onCompleted={completeSession} />}
              />
              <Redirect
                to={{
                  pathname: `/${BASE_PATH}/${ROUTES.identification}`,
                  search,
                }}
              />
            </Switch>
          </LoanApplicationContextProvider>
        </FormProvider>
      </Container>
    </RoutesWrapper>
  );
}

export default LoanApplicationRoutes;
